<template>
<div class="featured-content" v-html="featuredContent"></div>
</template>

<script>
export default {
  name: 'FeaturedSubHeader',
  props: {
    featuredContent: {}

  }
}
</script>